// extracted by mini-css-extract-plugin
module.exports = {"loginWrap":"Login_loginWrap__fyUIS","wrapInputs":"Login_wrapInputs__ypa0E"};